<div class="sortable-list">
  <label class="move-description">Use the arrow buttons to change group position</label>

  <div class="sortable-list-container">
    <div class="inner-sortable-list-container">
      <virtual-scroller #sortableListScroll [items]="filteredList ? filteredList : list"
                        checkResizeInterval="100" [enableUnequalChildrenSizes]="true" class="virtual-scroll-container">
        <div class="sortable-list-item" *ngFor="let item of sortableListScroll.viewPortItems"
             (click)="moveBelow(item)" [ngClass]="{'selected': isSelected(item)}">
          {{item[displayValue]}}
        </div>
      </virtual-scroller>
    </div>

    <div class="move-up-down-container">
      <button mat-icon-button (click)="moveUp()" [disabled]="!isUpAvailable()">
        <mat-icon>arrow_upward</mat-icon>
      </button>
      <button mat-icon-button (click)="moveDown()" [disabled]="!isDownAvailable()">
        <mat-icon>arrow_downward</mat-icon>
      </button>
    </div>
  </div>
</div>
